import Alpine from "alpinejs";
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

export const initHomeAbout = () => {
  Alpine.data("homeAbout", () => {
    return {
      init() {
        const root = this.$el as HTMLElement;
        const text = this.$refs.text as HTMLElement;
        const kyushuImage = this.$refs.kyushuImage as HTMLElement;
        const akadori = this.$refs.akadori as HTMLElement;
        const herbdori = this.$refs.herbdori as HTMLElement;
    
        gsap.set(text, {
          opacity: 0,
          yPercent: 20,
        });
        gsap.set(kyushuImage, {
          opacity: 0,
          yPercent: 10,
          transformOrigin: "right bottom",
        });
        gsap.set([akadori, herbdori], {
          opacity: 0,
          yPercent: 10,
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: root,
            start: "top center",
          },
        });
        tl.to(text, {
          opacity: 1,
          yPercent: 0,
          duration: 1.2,
          ease: "power2.out",
        },
        "0.2"
        )
        .to(kyushuImage, {
          opacity: 1,
          yPercent: 0,
          duration: 1.2,
          ease: "power2.out",
        },
        "<"
        )
        .to([akadori, herbdori], {
          opacity: 1,
          yPercent: 0,
          duration: 1.2,
          stagger: 0.3,
          ease: "power3.Out",
        },
        "-=1"
        )
      },
    };
  });
};
